import React from "react";
import MerchantLayout from "../../components/MerchantLayouts";
import MembershipLavel from "../../components/MemberShipProfile/MembershipLavel";
import MainLayout from "../../components/Layouts";

const MembershipLavelPage = () => {
  return (
    <MainLayout>
      <MembershipLavel /> 
    </MainLayout> 
  ); 
};

export default MembershipLavelPage;
